<template>
    <SimpleLayout
        :is-cookie-bar-visible="false"
        :is-application-bar-visibile="false"
    >
        <template #header>
            <HeaderGoodhome />
        </template>
    </SimpleLayout>
</template>

<script>
import SimpleLayout from './simple';
import HeaderGoodhome from '~/src/components/Header/HeaderGoodhome';

export default {
    name: 'Goodhome',
    components: {
        SimpleLayout,
        HeaderGoodhome,
    },
};
</script>
